export default __webpack_public_path__ + "static/media/top_demo_image_my_page.31462246.png";